import { render, staticRenderFns } from "./RoomView.vue?vue&type=template&id=0d2acb10&scoped=true"
import script from "./RoomView.vue?vue&type=script&lang=js"
export * from "./RoomView.vue?vue&type=script&lang=js"
import style0 from "./RoomView.vue?vue&type=style&index=0&id=0d2acb10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2acb10",
  null
  
)

export default component.exports